export * from './AnimalEnergyImage';
